import axiosInstance from '../../axios-config';

const contactUsContactsApi = '/api/facilities/{facilityId}/contacts';

export const getContacts = (facilityId) =>
  axiosInstance.get(contactUsContactsApi.replace('{facilityId}', facilityId));
